import {
  faCartPlus,
  faCheck,
  faHistory,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import OffSticker from "src/assets/images/website-images/off-sticker.png";
import Danger from "src/assets/images/website-images/danger.png";
import HeartUnFav from "src/assets/images/heart-un-favorite.png";
import CartPlus from "src/assets/images/website-images/addcart-image-new.png";
import GradientBtn from "../../GradientBtn";
import HistoryIcon from "src/assets/images/website-images/history-icon.png";
import RenderText from "src/Components/Text/RenderText";
import TestIcon from "src/assets/images/website-images/test-icon.png";
import BloodIcon from "src/assets/images/website-images/blood-icon.png";
import { Skeleton } from "@mui/material";
import { ImageBaseUrl } from "src/lib/constans";
import { useNavigate } from "react-router-dom";
import AddCartComponent from "src/Components/Customer/ProductsAndServicesComponents/AddCartComponent";
import HowManytDealOFF from "src/Components/GlobalComponents/HowManytDealOFF";
import PriceView from "src/Components/GlobalComponents/PriceView";
import FavoriteCoponent from "src/Components/GlobalComponents/FavoriteCoponent";

interface IProps {
  skeleton?: boolean;
  data?: any;
  id?: string;
  index?: number;
  onLikeProduct?: (id: string, isLiked: boolean) => void;
}

const BoxIcon = ({
  icon,
  title,
  skeleton,
}: {
  icon?: string;
  title: string;
  skeleton?: boolean;
}) => {
  return (
    <div className="flex gap-1 items-center">
      {skeleton ? (
        <>
          <Skeleton
            variant="rectangular"
            width={15}
            height={15}
            sx={{ borderRadius: "4px" }}
          />
          <Skeleton variant="text" width={50} height={12} />
        </>
      ) : (
        <>
          <div className="w-[15px] h-[15px] border border-gray-400 rounded flex items-center justify-center">
            <img
              src={icon}
              alt="icon"
              className="max-w-[80%] max-h-[80%] object-contain"
            />
          </div>
          <RenderText className="font-Poppins-Regular font-size-12px text-[#333333]">
            {title}
          </RenderText>
        </>
      )}
    </div>
  );
};

const LabTestProductCard = ({ skeleton, data, id, index, onLikeProduct }: IProps) => {
  const navigate = useNavigate();

  return (
    <div className="w-full">
      <div
        className="w-full bg-white product-card-radius border border-gray-300 shadow-md cursor-pointer"
        onClick={() => {
          if (!skeleton && data?._id) {
            navigate(`/diagnostic-product/test/${data?._id}/view`);
          }
        }}
        id={
          index || index === 0 ? `lab-test-product-card-${index + 1}` : id || ""
        }
      >
        <div className="w-full aspect-[1/0.7] product-card-radius-image relative bg-[#F6F6F6] overflow-hidden">
          {skeleton ? (
            <>
              <Skeleton
                variant="rectangular"
                width="100%"
                height="100%"
                sx={{ borderRadius: "8px 8px 0 0" }}
              />
              <div className="absolute top-0 left-0 w-[100%] h-fit p-2 flex justify-between">
                <Skeleton variant="rectangular" width={40} height={50} />
              </div>
              <div className="absolute bottom-0 left-0 w-[100%] h-fit px-2 flex items-center pb-1 justify-between">
                <Skeleton variant="rectangular" width={50} height={24} />
              </div>
            </>
          ) : (
            <>
              <div className="absolute top-0 left-0 w-[100%] h-fit p-2 flex justify-between">
                <HowManytDealOFF
                  regularPrice={data?.regularPrice}
                  salePrice={data?.salePrice}
                />
                <FavoriteCoponent
                  id={data?._id || ""}
                  category="tests"
                  liked={data?.isLiked || false}
                  index={index}
                  onLikeProduct={onLikeProduct}
                />
              </div>
              <img
                src={data?.productImage}
                alt={data?.productName || "Product"}
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 w-[100%] h-fit px-2 flex items-center pb-1 justify-between">
                <div className="px-2 py-1 font-size-12px rounded-xl bg-[#F59E0B] text-white flex items-center justify-center gap-1">
                  <FontAwesomeIcon icon={faStar} />
                  <span className="font-Lexend-Regular">
                    {data?.averageRating
                      ? data?.averageRating.toFixed(1)
                      : "0.0"}
                  </span>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="w-full p-2 flex flex-col justify-between gap-3 2xl:min-h-[200px] min-h-[160px] lg:min-h-[180px]">
          <div className="flex flex-col gap-2">
            {skeleton ? (
              <>
                <Skeleton variant="text" width="80%" height={24} />
                <div className="flex gap-3">
                  <BoxIcon title="Tests" skeleton={true} />
                  <BoxIcon title="Blood Sample" skeleton={true} />
                </div>
              </>
            ) : (
              <>
                <p className="font-Lexend-Regular font-size-18px line-clamp-2">
                  {data?.productName}
                </p>
                <div className="flex gap-3">
                  <BoxIcon
                    icon={TestIcon}
                    title={`${data?.noOfBiomarkers || 0} Biomarkers`}
                  />
                  <BoxIcon
                    icon={BloodIcon}
                    title={data?.testType ? data?.testType : "Blood Sample"}
                  />
                </div>
              </>
            )}
          </div>
          <div className="flex w-full flex-col gap-1 lg:gap-1.5 xl:gap-2">
            {skeleton ? (
              <>
                <Skeleton variant="text" width="60%" height={24} />
                <Skeleton variant="rectangular" width="100%" height={36} />
              </>
            ) : (
              <>
                <PriceView
                  salePrice={data?.salePrice}
                  regularPrice={data?.regularPrice}
                />
                <div className="flex">
                  <AddCartComponent
                    productId={data?._id}
                    id={
                      index || index === 0
                        ? `add-test-to-cart-${index + 1}`
                        : id || ""
                    }
                    type="diagnostic"
                    itemType="product"
                    prescriptionRequired={data?.prescriptionRequired}
                    quantity={1}
                    textBtn
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LabTestProductCard;
